export const PDF_CREATED = 'PDF_CREATED';
